module.exports = __webpack_public_path__ + "static/media/orderHistory.f5bf9a97.png";